import { memo } from 'react';
// hooks
import useAuth from '../hooks/useAuth';
// utils
import createAvatar from '../utils/createAvatar';
//
import Avatar from './Avatar';

// ----------------------------------------------------------------------

function CompanyAvatar({ ...other }) {
  const { user } = useAuth();
  const companyId = user?.employee.company?.[0]?.id || 1;
  const defaultLink = `https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/bji_${companyId%4 + 1}.png`;

  if (!companyId) return null;
  return (
    <Avatar
      src={defaultLink}
      alt={user?.name}
      color={user?.photoURL ? 'default' : createAvatar(user?.name).color}
      {...other}
    >
      {createAvatar(user?.name).name}
    </Avatar>
  );
}

export default memo(CompanyAvatar);
